<template>

  <div id="app">
    <header v-if="$page.component != 'Gyms/Home'">
      <div class="header_wrap">
        <div class="header_logo">
          <Link :href="route('gyms.home')" class="brand-logo">
            <Logo class="header_logo_img" width="163.5" height="28.5" alt="ロード・オブ・ザ・ウォール" />
          </Link>
        </div>
      </div>
    </header>
    <div class="header_guest" :class="{'home' : $page.component === 'Gyms/Home'}">
      <div class="header_guest_login">
        <Link class="header_guest_login_link" :href="route('login')">
          <img src="/images/common/btn-login-red.svg" alt="ログイン" />
        </Link>
      </div>
    </div>

    <!-- Page Content -->
    <main class="container" :class="{'home' : $page.component === 'Gyms/Home'}">
      <slot />
      <Side v-if="!($page.component == 'Gyms/Home' || $page.component == 'Privacy' || $page.component == 'Terms')" />
    </main>
  </div><!-- end #app -->
  <Footer />

</template>

<script>
import { ref } from 'vue';
// import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BreezeNavLink from '@/Components/NavLink.vue';
import BreezeResponsiveNavLink from '@/Components/ResponsiveNavLink.vue';
import { Link } from '@inertiajs/inertia-vue3';

import Logo from '@/Shared/Logo'
import Side from '@/Shared/Side'
import Footer from '@/Shared/Footer'

export default {
  components: {
    BreezeDropdown,
    BreezeDropdownLink,
    BreezeNavLink,
    BreezeResponsiveNavLink,
    Link,
    Logo,
    Side,
    Footer
  },
  data () {
    return {
      showNav: false
    }
  },
  // props: {
  //   initialComponent: Object,
  //   // auth: Object,
  // },
  // setup(){
  //   console.log(initialComponent);
  // }
  // props: {
  //   gyms: Array
  // },
  // computed: {
  //     hogeURL: function () {
  //       return '/home/' + props.auth.user.id
  //     }
  // }

}

</script>